import { Flex, Box } from 'theme-ui';
import ContentText from '@solid-ui-components/ContentText';
import { nanoid } from 'nanoid';
import { GatsbyImage } from 'gatsby-plugin-image';
import getImage from '@solid-ui-components/utils/getImage';

const styles = {
  flexBox: {
    flex: 1,
    padding: '0 30px 30px',
    h5: {
      fontWeight: 700,
    },
    img: {
      width: '60px',
      height: '60px',
      marginBottom: '1em',
    },
  },
  flex: {
    maxWidth: 1110,
    margin: '0 auto',
    textAlign: 'center',
    paddingTop: '27px',
    display: 'flex',
    flexDirection: ['column', 'column', 'column', 'row'],
    alignItems: 'center',
  },
};
type Image = {
  alt: string;
  src: any;
};
type Content = {
  image: Image;
  header: string;
  description: string;
};
type Props = { content: Array<Content>; style?: any };
const FlexBox = ({ content, style }: Props) => {
  const generalKey = nanoid();
  return (
    <Flex sx={{ ...styles.flex, ...style }} key={`${generalKey}-listWrapper`}>
      {content.map(({ image, header, description }, index) => (
        <Box
          sx={styles.flexBox}
          key={`${generalKey}-listElementWrapper-${index}`}
        >
          {image && (
            <GatsbyImage
              alt={image.alt}
              image={getImage({
                ...image.src,
                __typename: 'ImageSharp_medium_icon_square',
              })}
              loading='lazy'
              css={styles.flexBox.img}
            />
          )}
          <ContentText
            key={`${generalKey}-header-${index}`}
            content={{
              text: header,
            }}
            variant='h5'
          />
          <ContentText
            key={`${generalKey}-description-${index}`}
            content={{
              text: description,
            }}
            variant='p'
          />
        </Box>
      ))}
    </Flex>
  );
};
export default FlexBox;
